<template>
  <div class="customercase">
    <div>
      <img src="./customercase1.png" alt="" class="width100">
    </div>
    <div class="container case1">
      <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 por ">
            <img src="./customercase2.png" alt="" class="width100">
            <p class="tit">北京同仁堂</p>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 mt30 por minRig5">
            <img src="./customercase3.png" alt="" class="width100">
            <p class="tit">人川大药房</p>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 mt30 por minLeft5">
            <img src="./customercase4.png" alt="" class="width100">
            <p class="tit">海南口腔医院</p>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 mt30 por minRig5">
            <img src="./customercase5.png" alt="" class="width100">
            <p class="tit">清华玉泉医院</p>
          </div>
          <div class="col-xs-6 col-sm-6 col-md-6 mt30 por minLeft5">
            <img src="./customercase6.png" alt="" class="width100">
            <p class="tit">北京方舟医院</p>

          </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
    export default {};
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .customercase
    .case1
      padding:100px
    .mt30
      margin-top 30px
    .por
      position: relative
      .tit
        font-size 50px
        color:#fff
        white-space nowrap
        text-shadow:1px 1px 1px #840a0a
        position: absolute
        top:50%;
        left:50%
        transform translate(-50%,-50%)

@media (min-width: 320px) and (max-width: 750px)
  .customercase
    .case1
      padding:10px
    .por .tit
      font-size 18px
</style>



// WEBPACK FOOTER //
// src/components/customercase/customercase.vue